import { useState } from "react";
export const useShow = (defaultValue) => {
    const [open, setOpen] = useState(defaultValue || false);
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    return { open, onOpen, onClose };
};
